import React from "react";
import OfficeUnitForm from "./OfficeUnitForm";

export default function AddOfficeUnit() {
  return <OfficeUnitForm type={"Add"} />;
}
